module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei2.svg";